import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=b9bae2ca&scoped=true"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"
import style0 from "./StepTwo.vue?vue&type=style&index=0&id=b9bae2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bae2ca",
  null
  
)

export default component.exports